import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-context-jobs-home',
  templateUrl: './context-jobs-home.component.html',
  styleUrls: ['./context-jobs-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContextJobsHomeComponent {
  get isMobileAndTabletPortrait$(): Observable<boolean> {
    return this.breakpointsService.isMobileAndTabletPortrait$;
  }

  constructor(private readonly breakpointsService: BreakpointsService) {}
}

@NgModule({
  imports: [CommonModule, MatIconModule],
  declarations: [ContextJobsHomeComponent],
  exports: [ContextJobsHomeComponent],
})
export class ContextJobsHomeModule {}
